import styled from 'styled-components';

import InputSimple, { phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';

export const InputPhone = styled(phoneDecorator(InputSimple))`
    margin-bottom: 0;
`;
